
import BaseEPaperWidget from '../../../../base/components/sidebar/widgets/EPaperWidget.vue'

export default class EPaperWidget extends BaseEPaperWidget {}
